import React from "react";

const IndiaIcon = () => {
  return (
    <>
      <svg
        width="27"
        height="20"
        viewBox="0 0 27 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_142_1365)">
          <path d="M0 0H26.6667V6.66667H0V0Z" fill="#FF9933" />
          <path d="M0 6.6665H26.6667V13.3332H0V6.6665Z" fill="white" />
          <path d="M0 13.3335H26.6667V20.0002H0V13.3335Z" fill="#128807" />
          <path
            d="M13.3337 12.6668C14.8064 12.6668 16.0003 11.4729 16.0003 10.0002C16.0003 8.5274 14.8064 7.3335 13.3337 7.3335C11.8609 7.3335 10.667 8.5274 10.667 10.0002C10.667 11.4729 11.8609 12.6668 13.3337 12.6668Z"
            fill="#000088"
          />
          <path
            d="M13.3338 12.3337C14.6225 12.3337 15.6672 11.289 15.6672 10.0003C15.6672 8.71166 14.6225 7.66699 13.3338 7.66699C12.0452 7.66699 11.0005 8.71166 11.0005 10.0003C11.0005 11.289 12.0452 12.3337 13.3338 12.3337Z"
            fill="white"
          />
          <path
            d="M13.3334 10.467C13.5911 10.467 13.8 10.2581 13.8 10.0004C13.8 9.74263 13.5911 9.53369 13.3334 9.53369C13.0756 9.53369 12.8667 9.74263 12.8667 10.0004C12.8667 10.2581 13.0756 10.467 13.3334 10.467Z"
            fill="#000088"
          />
          <path
            d="M15.6311 10.424C15.6968 10.4327 15.7571 10.3864 15.7657 10.3207C15.7744 10.255 15.7281 10.1947 15.6624 10.1861C15.5967 10.1774 15.5364 10.2237 15.5278 10.2894C15.5191 10.3551 15.5654 10.4154 15.6311 10.424Z"
            fill="#000088"
          />
          <path
            d="M13.3334 12.3328L13.4134 10.9328L13.3334 10.2661L13.2534 10.9328L13.3334 12.3328Z"
            fill="#000088"
          />
          <path
            d="M15.4433 11.0045C15.5046 11.0298 15.5748 11.0008 15.6001 10.9395C15.6255 10.8783 15.5964 10.8081 15.5352 10.7827C15.474 10.7574 15.4038 10.7865 15.3784 10.8477C15.353 10.9089 15.3821 10.9791 15.4433 11.0045Z"
            fill="#000088"
          />
          <path
            d="M12.7299 12.2538L13.1695 10.9222L13.2648 10.2575L13.015 10.8808L12.7299 12.2538Z"
            fill="#000088"
          />
          <path
            d="M15.1107 11.5159C15.1633 11.5562 15.2386 11.5463 15.279 11.4937C15.3193 11.4412 15.3094 11.3658 15.2568 11.3255C15.2042 11.2851 15.1289 11.2951 15.0886 11.3476C15.0482 11.4002 15.0581 11.4756 15.1107 11.5159Z"
            fill="#000088"
          />
          <path
            d="M12.1663 12.0202L12.9356 10.8478L13.1997 10.2304L12.797 10.7678L12.1663 12.0202Z"
            fill="#000088"
          />
          <path
            d="M14.658 11.9244C14.6984 11.977 14.7737 11.9869 14.8263 11.9466C14.8789 11.9062 14.8888 11.8309 14.8484 11.7783C14.8081 11.7257 14.7328 11.7158 14.6802 11.7562C14.6276 11.7965 14.6177 11.8718 14.658 11.9244Z"
            fill="#000088"
          />
          <path
            d="M11.6836 11.6493L12.7301 10.7159L13.1449 10.1879L12.617 10.6028L11.6836 11.6493Z"
            fill="#000088"
          />
          <path
            d="M14.1152 12.2017C14.1406 12.263 14.2108 12.292 14.272 12.2667C14.3332 12.2413 14.3623 12.1711 14.3369 12.1099C14.3116 12.0487 14.2414 12.0196 14.1802 12.0449C14.1189 12.0703 14.0898 12.1405 14.1152 12.2017Z"
            fill="#000088"
          />
          <path
            d="M11.3132 11.1666L12.5656 10.5359L13.103 10.1332L12.4856 10.3973L11.3132 11.1666Z"
            fill="#000088"
          />
          <path
            d="M13.5194 12.329C13.5281 12.3947 13.5883 12.441 13.6541 12.4323C13.7198 12.4237 13.766 12.3634 13.7574 12.2977C13.7487 12.232 13.6884 12.1857 13.6227 12.1944C13.557 12.203 13.5108 12.2633 13.5194 12.329Z"
            fill="#000088"
          />
          <path
            d="M11.0811 10.6039L12.4541 10.3188L13.0773 10.069L12.4127 10.1642L11.0811 10.6039Z"
            fill="#000088"
          />
          <path
            d="M12.9105 12.2976C12.9018 12.3633 12.9481 12.4236 13.0138 12.4322C13.0795 12.4409 13.1397 12.3946 13.1484 12.3289C13.157 12.2632 13.1108 12.2029 13.0451 12.1943C12.9794 12.1856 12.9191 12.2319 12.9105 12.2976Z"
            fill="#000088"
          />
          <path
            d="M11.0012 9.99992L12.4012 10.0799L13.0679 9.99992L12.4012 9.91992L11.0012 9.99992Z"
            fill="#000088"
          />
          <path
            d="M12.33 12.1094C12.3046 12.1706 12.3337 12.2408 12.3949 12.2661C12.4562 12.2915 12.5264 12.2624 12.5517 12.2012C12.5771 12.14 12.548 12.0698 12.4868 12.0444C12.4256 12.019 12.3554 12.0481 12.33 12.1094Z"
            fill="#000088"
          />
          <path
            d="M11.0807 9.3959L12.4123 9.83552L13.077 9.93079L12.4537 9.68097L11.0807 9.3959Z"
            fill="#000088"
          />
          <path
            d="M11.8181 11.7782C11.7777 11.8308 11.7877 11.9061 11.8402 11.9465C11.8928 11.9868 11.9681 11.9769 12.0085 11.9243C12.0488 11.8717 12.0389 11.7964 11.9863 11.7561C11.9338 11.7157 11.8584 11.7256 11.8181 11.7782Z"
            fill="#000088"
          />
          <path
            d="M11.3138 8.8338L12.4862 9.60308L13.1036 9.86713L12.5662 9.46452L11.3138 8.8338Z"
            fill="#000088"
          />
          <path
            d="M11.4096 11.3255C11.357 11.3659 11.3471 11.4412 11.3874 11.4938C11.4278 11.5464 11.5031 11.5563 11.5557 11.5159C11.6083 11.4756 11.6182 11.4002 11.5778 11.3477C11.5375 11.2951 11.4622 11.2852 11.4096 11.3255Z"
            fill="#000088"
          />
          <path
            d="M11.6847 8.35059L12.6181 9.3971L13.1461 9.81194L12.7312 9.28397L11.6847 8.35059Z"
            fill="#000088"
          />
          <path
            d="M11.1318 10.7817C11.0705 10.8071 11.0415 10.8773 11.0668 10.9385C11.0922 10.9997 11.1624 11.0288 11.2236 11.0034C11.2848 10.9781 11.3139 10.9079 11.2886 10.8467C11.2632 10.7854 11.193 10.7563 11.1318 10.7817Z"
            fill="#000088"
          />
          <path
            d="M12.1669 7.97971L12.7976 9.23214L13.2002 9.76949L12.9362 9.15214L12.1669 7.97971Z"
            fill="#000088"
          />
          <path
            d="M11.0045 10.1849C10.9388 10.1936 10.8925 10.2539 10.9012 10.3196C10.9098 10.3853 10.9701 10.4315 11.0358 10.4229C11.1015 10.4142 11.1478 10.354 11.1391 10.2883C11.1305 10.2225 11.0702 10.1763 11.0045 10.1849Z"
            fill="#000088"
          />
          <path
            d="M12.7301 7.74663L13.0152 9.11963L13.265 9.74287L13.1697 9.07822L12.7301 7.74663Z"
            fill="#000088"
          />
          <path
            d="M11.0354 9.57598C10.9697 9.56733 10.9094 9.61358 10.9008 9.67929C10.8921 9.745 10.9384 9.80528 11.0041 9.81393C11.0698 9.82258 11.1301 9.77632 11.1387 9.71062C11.1474 9.64491 11.1011 9.58463 11.0354 9.57598Z"
            fill="#000088"
          />
          <path
            d="M13.3331 7.66722L13.2531 9.06722L13.3331 9.73389L13.4131 9.06722L13.3331 7.66722Z"
            fill="#000088"
          />
          <path
            d="M11.2232 8.99553C11.1619 8.97017 11.0917 8.99924 11.0664 9.06047C11.041 9.1217 11.0701 9.1919 11.1313 9.21726C11.1926 9.24262 11.2627 9.21355 11.2881 9.15232C11.3135 9.09109 11.2844 9.02089 11.2232 8.99553Z"
            fill="#000088"
          />
          <path
            d="M13.9371 7.74672L13.4975 9.07831L13.4022 9.74297L13.652 9.11972L13.9371 7.74672Z"
            fill="#000088"
          />
          <path
            d="M11.5563 8.48361C11.5037 8.44327 11.4284 8.45319 11.388 8.50577C11.3477 8.55834 11.3576 8.63367 11.4102 8.67402C11.4627 8.71436 11.5381 8.70445 11.5784 8.65187C11.6188 8.59929 11.6089 8.52396 11.5563 8.48361Z"
            fill="#000088"
          />
          <path
            d="M14.5007 7.9793L13.7314 9.15173L13.4673 9.76908L13.87 9.23173L14.5007 7.9793Z"
            fill="#000088"
          />
          <path
            d="M12.009 8.07559C11.9686 8.02301 11.8933 8.01309 11.8407 8.05344C11.7881 8.09378 11.7782 8.16911 11.8186 8.22169C11.8589 8.27427 11.9342 8.28419 11.9868 8.24384C12.0394 8.2035 12.0493 8.12817 12.009 8.07559Z"
            fill="#000088"
          />
          <path
            d="M14.9834 8.35073L13.9369 9.28411L13.522 9.81208L14.05 9.39725L14.9834 8.35073Z"
            fill="#000088"
          />
          <path
            d="M12.5528 7.79827C12.5274 7.73704 12.4572 7.70796 12.396 7.73332C12.3347 7.75869 12.3057 7.82888 12.331 7.89011C12.3564 7.95134 12.4266 7.98042 12.4878 7.95505C12.549 7.92969 12.5781 7.8595 12.5528 7.79827Z"
            fill="#000088"
          />
          <path
            d="M15.3548 8.83342L14.1023 9.46414L13.565 9.86675L14.1823 9.6027L15.3548 8.83342Z"
            fill="#000088"
          />
          <path
            d="M13.15 7.67099C13.1414 7.60528 13.0811 7.55903 13.0154 7.56768C12.9497 7.57633 12.9034 7.63661 12.9121 7.70232C12.9207 7.76802 12.981 7.81428 13.0467 7.80563C13.1124 7.79698 13.1587 7.7367 13.15 7.67099Z"
            fill="#000088"
          />
          <path
            d="M15.5883 9.39662L14.2153 9.68169L13.5921 9.93151L14.2567 9.83624L15.5883 9.39662Z"
            fill="#000088"
          />
          <path
            d="M13.759 7.70288C13.7676 7.63717 13.7214 7.57689 13.6557 7.56824C13.59 7.55959 13.5297 7.60585 13.521 7.67155C13.5124 7.73726 13.5586 7.79754 13.6243 7.80619C13.6901 7.81484 13.7503 7.76859 13.759 7.70288Z"
            fill="#000088"
          />
          <path
            d="M15.6682 10.0006L14.2682 9.92057L13.6016 10.0006L14.2682 10.0806L15.6682 10.0006Z"
            fill="#000088"
          />
          <path
            d="M14.338 7.89113C14.3633 7.82991 14.3343 7.75971 14.273 7.73435C14.2118 7.70899 14.1416 7.73806 14.1162 7.79929C14.0909 7.86052 14.1199 7.93072 14.1812 7.95608C14.2424 7.98144 14.3126 7.95236 14.338 7.89113Z"
            fill="#000088"
          />
          <path
            d="M15.5878 10.6046L14.2562 10.165L13.5915 10.0697L14.2148 10.3195L15.5878 10.6046Z"
            fill="#000088"
          />
          <path
            d="M14.8499 8.22278C14.8902 8.1702 14.8803 8.09487 14.8277 8.05452C14.7752 8.01418 14.6998 8.02409 14.6595 8.07667C14.6191 8.12925 14.629 8.20458 14.6816 8.24493C14.7342 8.28527 14.8095 8.27535 14.8499 8.22278Z"
            fill="#000088"
          />
          <path
            d="M15.3542 11.1672L14.1818 10.3979L13.5644 10.1338L14.1018 10.5365L15.3542 11.1672Z"
            fill="#000088"
          />
          <path
            d="M15.2584 8.67546C15.311 8.63511 15.3209 8.55978 15.2805 8.50721C15.2402 8.45463 15.1649 8.44471 15.1123 8.48505C15.0597 8.5254 15.0498 8.60073 15.0901 8.65331C15.1305 8.70589 15.2058 8.7158 15.2584 8.67546Z"
            fill="#000088"
          />
          <path
            d="M14.9833 11.6504L14.0499 10.6039L13.5219 10.189L13.9367 10.717L14.9833 11.6504Z"
            fill="#000088"
          />
          <path
            d="M15.5362 9.21878C15.5974 9.19342 15.6265 9.12322 15.6011 9.06199C15.5758 9.00076 15.5056 8.97168 15.4444 8.99705C15.3831 9.02241 15.3541 9.0926 15.3794 9.15383C15.4048 9.21506 15.475 9.24414 15.5362 9.21878Z"
            fill="#000088"
          />
          <path
            d="M14.5011 12.0208L13.8703 10.7683L13.4677 10.231L13.7318 10.8483L14.5011 12.0208Z"
            fill="#000088"
          />
          <path
            d="M15.6635 9.81555C15.7292 9.80689 15.7754 9.74662 15.7668 9.68091C15.7581 9.6152 15.6979 9.56895 15.6322 9.5776C15.5664 9.58625 15.5202 9.64653 15.5288 9.71224C15.5375 9.77794 15.5978 9.8242 15.6635 9.81555Z"
            fill="#000088"
          />
          <path
            d="M13.9379 12.2539L13.6528 10.8809L13.403 10.2576L13.4982 10.9223L13.9379 12.2539Z"
            fill="#000088"
          />
        </g>
        <defs>
          <clipPath id="clip0_142_1365">
            <rect width="26.6667" height="20" rx="3.33333" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default IndiaIcon;
